import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.regexp.replace.js";
import Nl2br from 'vue-nl2br';
var Modal = function Modal() {
  return import('@/components/organisms/Modal');
};
var PageTitle = function PageTitle() {
  return import('@/components/molecules/PageTitle');
};
var PageHeader = function PageHeader() {
  return import('@/components/molecules/PageHeader');
};
var LikeButton = function LikeButton() {
  return import('@/components/molecules/LikeButton');
};
var RarityIcon = function RarityIcon() {
  return import('@/components/atoms/RarityIcon');
};
var ShareModal = function ShareModal() {
  return import('@/components/organisms/ShareModal');
};
var SellModal = function SellModal() {
  return import('@/components/organisms/SellModal');
};
var CountDown = function CountDown() {
  return import('@/components/molecules/CountDown');
};
var ExternalLink = function ExternalLink() {
  return import('@/components/atoms/ExternalLink');
};
var UnitImage = function UnitImage() {
  return import('@/components/atoms/UnitImage');
};
var ChangeNetworkModal = function ChangeNetworkModal() {
  return import('@/components/organisms/ChangeNetworkModal');
};
var OutgameDepositModal = function OutgameDepositModal() {
  return import('@/components/organisms/OutgameDepositModal');
};
var AddArtModal = function AddArtModal() {
  return import('@/components/organisms/AddArtModal');
};
var ChangeSkillModal = function ChangeSkillModal() {
  return import('@/components/organisms/ChangeSkillModal');
};
var ParamsPrediction = function ParamsPrediction() {
  return import('@/components/molecules/ParamsPrediction');
};
var TrendsPrediction = function TrendsPrediction() {
  return import('@/components/molecules/TrendsPrediction');
};
var TrendsDetail = function TrendsDetail() {
  return import('@/components/molecules/TrendsDetail');
};
import heroCe from '~/assets/data/heroCe.json';
import { EthereumNetwork, HomeverseNetwork, MaticNetwork } from '@/lib/wallet';
import { useWalletStore } from '@/stores/useWalletStore';
var CompositionSphereModal = function CompositionSphereModal() {
  return import('@/components/organisms/CompositionSphereModal');
};
var AssetGiftButton = function AssetGiftButton() {
  return import('@/components/atoms/AssetGiftButton');
};
var CharacteristicEnhancement = function CharacteristicEnhancement() {
  return import('@/components/molecules/CharacteristicEnhancement');
};
var Certificate = function Certificate() {
  return import('@/components/organisms/Certificate');
};
var TrainingDetail = function TrainingDetail() {
  return import('@/components/molecules/TrainingDetail');
};
var NoneSwitchNetworkModal = function NoneSwitchNetworkModal() {
  return import('@/components/organisms/NoneSwitchNetworkModal');
};
var ExUnitModal = function ExUnitModal() {
  return import('@/components/organisms/ExUnitModal');
};
var PpdOrIngotModal = function PpdOrIngotModal() {
  return import('@/components/organisms/PpdOrIngotModal');
};
var PpdHeroLvMaxModal = function PpdHeroLvMaxModal() {
  return import('@/components/organisms/PpdHeroLvMaxModal');
};
var PrimeIcon = function PrimeIcon() {
  return import('@/components/atoms/PrimeIcon');
};
export default {
  components: {
    Nl2br: Nl2br,
    Modal: Modal,
    PageTitle: PageTitle,
    LikeButton: LikeButton,
    PageHeader: PageHeader,
    RarityIcon: RarityIcon,
    ShareModal: ShareModal,
    SellModal: SellModal,
    CountDown: CountDown,
    ExternalLink: ExternalLink,
    UnitImage: UnitImage,
    AddArtModal: AddArtModal,
    ChangeSkillModal: ChangeSkillModal,
    ParamsPrediction: ParamsPrediction,
    TrainingDetail: TrainingDetail,
    TrendsPrediction: TrendsPrediction,
    CompositionSphereModal: CompositionSphereModal,
    TrendsDetail: TrendsDetail,
    CharacteristicEnhancement: CharacteristicEnhancement,
    Certificate: Certificate,
    AssetGiftButton: AssetGiftButton,
    NoneSwitchNetworkModal: NoneSwitchNetworkModal,
    ExUnitModal: ExUnitModal,
    PpdOrIngotModal: PpdOrIngotModal,
    PpdHeroLvMaxModal: PpdHeroLvMaxModal,
    ChangeNetworkModal: ChangeNetworkModal,
    OutgameDepositModal: OutgameDepositModal,
    PrimeIcon: PrimeIcon
  },
  // validate({ params }) {
  //   return /^[0-9]{8,10}$/.test(params.id)
  // },
  scrollToTop: true,
  data: function data() {
    return {
      isModalShown: false,
      isWikiModalShown: false,
      isTransferModalShown: false,
      isWithdrawModalShown: false,
      isNetworkSeletModalShown: false,
      isLockModalShown: false,
      isSellModalShown: false,
      isShareModalShown: false,
      isStatusRefreshModalShown: false,
      isAfterStatusRefresh: false,
      isRefreshAnimation: false,
      isUpConvertModalShown: false,
      herogateway: null,
      owner: null,
      likes: [],
      numberOfTransfered: 0,
      previousHero: {},
      isLoaded: false,
      isEditAssetModalShown: false,
      isTransferAssetModalShown: false,
      isGiftAssetModalShown: false,
      isAddArtModalShown: false,
      isChangeSkillModalShown: false,
      isMyUser: true,
      isTeaming: false,
      isTeamingData: [],
      isTeamingRemovalModalShown: false,
      supplyLimit: 0,
      transferLockRemainingSec: 0,
      compositionModalShown: false,
      upConvertCheck: false,
      upConvertHero: [],
      consumeItems: [],
      useConsumeItem: false,
      useTicketId: 1001,
      isRestrictionModalShown: false,
      isTrendsDetailModalShown: false,
      isSkillTreeShown: false,
      isSkillTreeDetailShown: false,
      isCertificateShown: false,
      isTrainingParamCheckModalShown: false,
      outFee: 0,
      networkType: 0,
      isNoneSwitchNetworkModal: false,
      withdrawErrors: [],
      isExAscension: false,
      exAscensionModalShown: false,
      exLevelUpModalShown: false,
      ppdCompositionModalShown: false,
      ingotCompositionModalShown: false,
      ppdBalance: 0,
      isLoading: true,
      changeNetworkModalOpen: false,
      changeNetworkNumber: 0,
      depositModalOpen: false
    };
  },
  computed: {
    myOwnEthHeroIds: function myOwnEthHeroIds() {
      return useHeroStore().myOwnEthIds;
    },
    myOwnMaticHeroIds: function myOwnMaticHeroIds() {
      return useHeroStore().myOwnMaticIds;
    },
    myOwnOasysHeroIds: function myOwnOasysHeroIds() {
      return useHeroStore().myOwnOasysIds;
    },
    getHero: function getHero() {
      return useHeroStore().getHero;
    },
    getExplorerUri: function getExplorerUri() {
      return useHeroStore().getExplorerUri;
    },
    networkName: function networkName() {
      return useAuthStore().getNetworkName;
    },
    isHeroApproved: function isHeroApproved() {
      return useAuthStore().getIsHeroApproved;
    },
    isPhoneValid: function isPhoneValid() {
      return usePhoneNumberStore().isPhoneValid;
    },
    me: function me() {
      return useUserStore().me;
    },
    getUser: function getUser() {
      return useUserStore().getUser;
    },
    userId: function userId() {
      return useAuthStore().getUserId;
    },
    networkBool: function networkBool() {
      return useAuthStore().getNetworkBool;
    },
    isMe: function isMe() {
      return this.isMyUser;
    },
    id: function id() {
      return Number(this.$route.params.id);
    },
    hero: function hero() {
      return this.getHero(this.id);
    },
    user: function user() {
      if (!this.owner) {
        return {};
      }
      return this.getUser(this.owner.uid);
    },
    isPrime: function isPrime() {
      return usePrimeStore().isPrime;
    },
    status: function status() {
      if (this.hero.lock === 2) return 'In Team';
      if (!this.owner) return;
      if (this.owner.uid === 2) return 'On Ethereum Network';
      if (this.owner.uid === 5) return 'Trading';
    },
    notValidNetwork: function notValidNetwork() {
      return !this.networkBool.isEth && !this.networkBool.isMatic && !this.networkBool.isHomeverse;
    },
    isMyOwnEthHero: function isMyOwnEthHero() {
      return this.myOwnEthHeroIds.includes(this.id);
    },
    isMyOwnMaticHero: function isMyOwnMaticHero() {
      return this.myOwnMaticHeroIds.includes(this.id);
    },
    isMyOwnOasysHero: function isMyOwnOasysHero() {
      return this.myOwnOasysHeroIds.includes(this.id);
    },
    isMyOwn: function isMyOwn() {
      if (!this.owner) {
        return false;
      }
      return this.owner.uid === this.userId;
    },
    isOnEth: function isOnEth() {
      if (!this.owner) {
        return false;
      }
      return this.owner.uid === 2;
    },
    isOnTrade: function isOnTrade() {
      if (!this.owner) {
        return false;
      }
      return this.owner.uid === 5;
    },
    isSpecialOwner: function isSpecialOwner() {
      return this.isOnEth || this.isOnTrade;
    },
    canAction: function canAction() {
      return this.isMyOwn && (this.hero.lock === 0 || this.hero.lock === 2 || this.hero.lock === 4 || this.hero.lock === 6);
    },
    checkExistence: function checkExistence() {
      var result = false;

      // デルター召喚の場合は通す
      if (this.hero.heroId > 200000000) return true;

      // masterのtypeで始まる
      if (String(this.hero.heroId).indexOf(String(this.hero.heroType)) == 0) {
        var id = this.hero.heroId;
        var typeId = this.hero.heroType;
        var checkLimit = id % typeId;

        // 発行数内である
        if (checkLimit <= this.supplyLimit) {
          result = true;
        }
      }
      return result;
    },
    cannotWithdraw: function cannotWithdraw() {
      return false;
      return this.notValidNetwork || this.hero.lock !== 0 || this.ppdBalance < this.outFee || this.numberOfTransfered > this.$constants.WITHDRAW_LIMIT_IN_A_DAY || this.artEditHistoryLength === 0 || this.hero.lv <= 1 || !this.isPhoneValid;
    },
    isRepHero: function isRepHero() {
      return !this.hero.asset && !!this.hero.rarity;
    },
    currentUrl: function currentUrl() {
      if (process.server) return;
      var path = this.localePath({
        name: 'heroes-id-index',
        params: {
          id: this.hero.heroId
        }
      });
      return "".concat(this.$env.siteUrl.slice(0, -1)).concat(path);
    },
    twitterText: function twitterText() {
      return encodeURIComponent(this.$t('twitter.hero'));
    },
    now: function now() {
      return this.$dayjs();
    },
    canTransferAsset: function canTransferAsset() {
      // 0以下をバックから取得している場合は
      // 明示的にTransferできない仕様
      return true;
      return this.transferLockRemainingSec >= 0;
    },
    isNewMintedAsset: function isNewMintedAsset() {
      return false;
      return +this.now.format('X') < +this.passed24Hours.format('X');
    },
    passed24Hours: function passed24Hours() {
      return this.$dayjs(this.transferLockRemainingSec * 1000);
    },
    predictHeroExp: function predictHeroExp() {
      if (this.isLessThanNeededCE) {
        return '---';
      } else {
        return this.hero.exp - this.$constants.HERO_PARAM_REFRESH_CE;
      }
    },
    isLessThanNeededCE: function isLessThanNeededCE() {
      // TODO: 経験値の処理を戻す
      return this.hero.exp < this.$constants.HERO_PARAM_REFRESH_CE;
    },
    standardFilter: function standardFilter() {
      return {
        tradeStatus: [1, 2],
        rarity: [],
        isOnlyStared: false,
        sortId: 1,
        assetType: null
      };
    },
    artEditHistoryLength: function artEditHistoryLength() {
      return this.hero.artHistory.length;
    },
    getLv: function getLv() {
      var exp = this.hero.exp - this.$constants.HERO_PARAM_REFRESH_CE;
      if (exp <= 0) return 0;
      for (var i = 1; i < 101; i++) {
        if (i == 100) return 100;
        if (exp >= heroCe[i] && exp < heroCe[i + 1]) {
          return i;
        }
      }
    },
    getNextExp: function getNextExp() {
      var exp = this.hero.exp - this.$constants.HERO_PARAM_REFRESH_CE;
      return heroCe[this.getLv + 1] - exp;
    },
    getExpPercentage: function getExpPercentage() {
      return 100 - this.getNextExp / (heroCe[this.getLv + 1] - heroCe[this.getLv]) * 100;
    },
    raritiesMaxLv: function raritiesMaxLv() {
      return [{
        id: 0,
        lv: 40
      }, {
        id: 1,
        lv: 60
      }, {
        id: 2,
        lv: 70
      }, {
        id: 3,
        lv: 80
      }, {
        id: 4,
        lv: 90
      }, {
        id: 5,
        lv: 100
      }];
    },
    isLvMax: function isLvMax() {
      return this.hero.lv >= this.raritiesMaxLv[this.hero.rarity].lv;
    },
    ticketCount: function ticketCount() {
      var _this = this;
      var count = 0;
      var item = this.consumeItems.find(function (x) {
        return x.consumeItemId == _this.useTicketId;
      });
      if (item) count = item.balance;
      return count;
    },
    noTicket: function noTicket() {
      return this.useConsumeItem && this.ticketCount == 0;
    },
    refreshParamItem: function refreshParamItem() {
      var items = this.consumeItems.filter(function (x) {
        return x.consumeItemId >= 1001 && x.consumeItemId <= 1007;
      }) || [];
      return items.sort(function (p, c) {
        if (p.consumeItemId < c.consumeItemId) return -1;
        if (p.consumeItemId > c.consumeItemId) return 1;
        return 0;
      });
    },
    heroParams: function heroParams() {
      var params = this.$util.clone(this.hero.param);
      if (this.hero.lbParam) {
        params.agi = params.agi + this.hero.lbParam.agi;
        params.hp = params.hp + this.hero.lbParam.hp;
        params.int = params.int + this.hero.lbParam.pb_int;
        params.mnd = params.mnd + this.hero.lbParam.mnd;
        params.phy = params.phy + this.hero.lbParam.phy;
        params.vit = params.vit + this.hero.lbParam.vit;
      }
      return params;
    },
    upConvertParam: function upConvertParam() {
      var params = this.$util.clone(this.upConvertHero.param);
      if (this.upConvertHero.lbParam) {
        params.agi = params.agi + this.upConvertHero.lbParam.agi;
        params.hp = params.hp + this.upConvertHero.lbParam.hp;
        params.int = params.int + this.upConvertHero.lbParam.pb_int;
        params.mnd = params.mnd + this.upConvertHero.lbParam.mnd;
        params.phy = params.phy + this.upConvertHero.lbParam.phy;
        params.vit = params.vit + this.upConvertHero.lbParam.vit;
      }
      return params;
    },
    heroUpPer: function heroUpPer() {
      if (!this.hero.training || !!this.hero.training && !Object.keys(this.hero.training).length) return 0;
      var param = this.hero.training;
      return Math.floor((param.hp + param.phy + param.pb_int + param.vit + param.mnd + param.agi) / 6 / 100);
    }
  },
  beforeMount: function beforeMount() {
    var _this2 = this;
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var userId, market, supplyData, lockData;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _this2.fetchEthHeroIds();
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            console.log(_context.t0);
          case 8:
            _context.next = 10;
            return Promise.all([_this2.fetchHero(_this2.id), _this2.getOwner()]);
          case 10:
            _this2.isLoaded = true;
            userId = _this2.$route.query.uid;
            market = _this2.$route.query.market;
            if (market) {
              _this2.isMyUser = false;
            } else if (userId != null && _this2.me != null) {
              _this2.isMyUser = _this2.me.uid === Number(userId);
            }
            _context.next = 16;
            return _this2.fetchEquippedData();
          case 16:
            _context.next = 18;
            return _this2.$heroesService.getHeroTypeSupply(_this2.hero.heroType);
          case 18:
            supplyData = _context.sent;
            _this2.supplyLimit = Number(supplyData.supply);
            _context.next = 22;
            return _this2.$heroesService.getLockTransferUntil(_this2.id);
          case 22:
            lockData = _context.sent;
            _this2.transferLockRemainingSec = Number(lockData.until);
            _context.next = 26;
            return _this2.updateOutFee();
          case 26:
            _this2.ppdBalance = useAddressStore().getPpdBalance;
            _this2.isLoading = false;
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }))();
  },
  methods: {
    fetchEthHeroIds: function fetchEthHeroIds() {
      return useHeroStore().fetchEthHeroIds();
    },
    fetchHero: function fetchHero(id) {
      return useHeroStore().fetchHero(id);
    },
    fetchRefreshedHero: function fetchRefreshedHero(ids) {
      return useHeroStore().fetchRefreshedHero(ids);
    },
    getConsumeItem: function getConsumeItem(id) {
      return useConsumableMaster().getConsumeItem(id);
    },
    exAscensionProcess: function exAscensionProcess(heroItems, targetId, isExAscension) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (!isExAscension) {
                _context2.next = 6;
                break;
              }
              _context2.next = 4;
              return _this3.$heroesService.exAscensionPhaseUp(heroItems, targetId);
            case 4:
              _context2.next = 8;
              break;
            case 6:
              _context2.next = 8;
              return _this3.$heroesService.exAscensionLevelUp(targetId);
            case 8:
              _context2.next = 10;
              return _this3.fetchHero(_this3.id);
            case 10:
              _this3.exAscensionModalShown = false;
              _this3.exLevelUpModalShown = false;
              _this3.$toast.success('Success.');
              _context2.next = 19;
              break;
            case 15:
              _context2.prev = 15;
              _context2.t0 = _context2["catch"](0);
              console.error(_context2.t0);
              _this3.$toast.error(_context2.t0);
            case 19:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 15]]);
      }))();
    },
    onGift: function onGift() {
      var explorerUrl = "".concat(this.$constants.EXPLORER, "/").concat(this.getExplorerUri(this.id));
      open(explorerUrl, '_blank');
    },
    visitMarketPlace: function visitMarketPlace() {
      if (this.isMyOwnMaticHero) {
        // let explorerUrl = `https://nanakusa.io/assets/${this.getExplorerUri(this.id)}`
        var explorerUrl = "https://tofunft.com/ja/collection/bfh-unit/items";
        open(explorerUrl, '_blank');
      } else if (this.isMyOwnEthHero) {
        var _explorerUrl = "https://opensea.io/assets/".concat(this.getExplorerUri(this.id));
        open(_explorerUrl, '_blank');
      } else if (this.isMyOwnOasysHero) {
        var _explorerUrl2 = "https://tofunft.com/nft/home-verse/0x3e1fc434eE0197a3309ad0df1Af96C2D6E7706F6/".concat(this.id);
        open(_explorerUrl2, '_blank');
      }
    },
    getOwner: function getOwner() {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 3;
              return _this4.$heroesService.getOwnerId(_this4.id);
            case 3:
              _this4.owner = _context3.sent;
              if (!_this4.isMyOwn) {
                _context3.next = 11;
                break;
              }
              _this4.numberOfTransfered = _this4.$constants.WITHDRAW_LIMIT_IN_A_DAY + 1;
              _context3.next = 8;
              return _this4.$usersService.getNumberOfTransfered();
            case 8:
              _this4.numberOfTransfered = _context3.sent;
              _context3.next = 14;
              break;
            case 11:
              if (_this4.isSpecialOwner) {
                _context3.next = 14;
                break;
              }
              _context3.next = 14;
              return useUserStore().fetchUser(_this4.owner.uid);
            case 14:
              _context3.next = 19;
              break;
            case 16:
              _context3.prev = 16;
              _context3.t0 = _context3["catch"](0);
              console.log(_context3.t0);
            case 19:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 16]]);
      }))();
    },
    requestMaticNetwork: function requestMaticNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return useWalletStore().switchNetwork(MaticNetwork);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    requestHomeverseNetwork: function requestHomeverseNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return useWalletStore().switchNetwork(HomeverseNetwork);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    requestEthNetwork: function requestEthNetwork() {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return useWalletStore().switchNetwork(EthereumNetwork);
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    changeMaticNetwork: function changeMaticNetwork() {
      try {
        useWalletStore().switchNetwork(MaticNetwork);
      } catch (e) {
        this.isNoneSwitchNetworkModal = true;
        console.error(e);
      }
    },
    changeHomeverseNetwork: function changeHomeverseNetwork() {
      try {
        useWalletStore().switchNetwork(HomeverseNetwork);
      } catch (e) {
        this.isNoneSwitchNetworkModal = true;
        console.error(e);
      }
    },
    changeEthNetwork: function changeEthNetwork() {
      this.isNoneSwitchNetworkModal = true;
    },
    openSellModal: function openSellModal() {
      this.isTransferAssetModalShown = false;
      this.isSellModalShown = true;
    },
    closeSellModal: function closeSellModal() {
      this.isSellModalShown = false;
    },
    openStatusRefreshModal: function openStatusRefreshModal() {
      var _this5 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this5.isEditAssetModalShown = false;
              _this5.isAfterStatusRefresh = false;
              _this5.isStatusRefreshModalShown = true;
              _context7.next = 5;
              return _this5.$itemsService.getConsumeItemsByProcType(100);
            case 5:
              _this5.consumeItems = _context7.sent;
            case 6:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    closeStatusRefreshModal: function closeStatusRefreshModal() {
      if (!this.isAfterStatusRefresh) {
        this.forceCloseStatusRefreshModal();
      }
    },
    forceCloseStatusRefreshModal: function forceCloseStatusRefreshModal() {
      this.isAfterStatusRefresh = false;
      this.isStatusRefreshModalShown = false;
    },
    tryWithdraw: function tryWithdraw(lockStatus) {
      this.isTransferAssetModalShown = false;
      if (lockStatus !== 0) {
        this.isLockModalShown = true;
        return;
      } else {
        this.withdrawErrors = this.getWithdrawErrors();
        this.isNetworkSeletModalShown = true;
        return;
      }
    },
    tryGumSell: function tryGumSell(lockStatus) {
      this.isTransferAssetModalShown = false;
      if (lockStatus !== 0) {
        this.isLockModalShown = true;
        return;
      } else {
        this.openSellModal();
        return;
      }
    },
    sell: function sell(_ref) {
      var _this6 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var startPrice, endPrice, redirectTo;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              startPrice = _ref.startPrice, endPrice = _ref.endPrice;
              _context8.prev = 1;
              _context8.next = 4;
              return _this6.$tradesService.sellHero(_this6.id, startPrice, endPrice);
            case 4:
              _context8.next = 6;
              return Promise.all([_this6.fetchHero(_this6.id), _this6.getOwner()]);
            case 6:
              _this6.closeSellModal();
              _this6.$toast.success('Success.');
              redirectTo = _this6.localePath({
                name: 'users-id-units-index-ingame',
                params: {
                  id: _this6.me.uid
                }
              });
              _this6.$router.push(redirectTo);
              _context8.next = 15;
              break;
            case 12:
              _context8.prev = 12;
              _context8.t0 = _context8["catch"](1);
              _this6.$toast.error(_context8.t0.message || 'Error.');
            case 15:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[1, 12]]);
      }))();
    },
    onApproveClicked: function onApproveClicked() {
      var _this7 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var gatewayContractAddress;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              gatewayContractAddress = useWalletStore().heroGateway.contract.address;
              _context9.prev = 1;
              _context9.next = 4;
              return useAuthStore().approve(gatewayContractAddress);
            case 4:
              _context9.next = 10;
              break;
            case 6:
              _context9.prev = 6;
              _context9.t0 = _context9["catch"](1);
              console.error(_context9.t0);
              _this7.$toast.error('Cancelled.');
            case 10:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[1, 6]]);
      }))();
    },
    deposit: function deposit() {
      var _this8 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var redirectTo;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!(_this8.networkBool.isEth && (_this8.isMyOwnMaticHero || _this8.isMyOwnOasysHero))) {
                _context10.next = 11;
                break;
              }
              if (!_this8.isMyOwnMaticHero) {
                _context10.next = 6;
                break;
              }
              _context10.next = 4;
              return _this8.requestMaticNetwork();
            case 4:
              _context10.next = 8;
              break;
            case 6:
              _context10.next = 8;
              return _this8.requestHomeverseNetwork();
            case 8:
              _this8.$router.push(_this8.localePath({
                name: 'users-id-units-index-outgame',
                params: {
                  id: _this8.me.uid
                }
              }));
              _context10.next = 43;
              break;
            case 11:
              if (!(_this8.networkBool.isMatic && (_this8.isMyOwnEthHero || _this8.isMyOwnOasysHero))) {
                _context10.next = 22;
                break;
              }
              if (!_this8.isMyOwnEthHero) {
                _context10.next = 17;
                break;
              }
              _context10.next = 15;
              return _this8.requestEthNetwork();
            case 15:
              _context10.next = 19;
              break;
            case 17:
              _context10.next = 19;
              return _this8.requestHomeverseNetwork();
            case 19:
              _this8.$router.push(_this8.localePath({
                name: 'users-id-units-index-outgame',
                params: {
                  id: _this8.me.uid
                }
              }));
              _context10.next = 43;
              break;
            case 22:
              if (!(_this8.networkBool.isHomeverse && (_this8.isMyOwnEthHero || _this8.isMyOwnMaticHero))) {
                _context10.next = 33;
                break;
              }
              if (!_this8.isMyOwnEthHero) {
                _context10.next = 28;
                break;
              }
              _context10.next = 26;
              return _this8.requestEthNetwork();
            case 26:
              _context10.next = 30;
              break;
            case 28:
              _context10.next = 30;
              return _this8.requestMaticNetwork();
            case 30:
              _this8.$router.push(_this8.localePath({
                name: 'users-id-units-index-outgame',
                params: {
                  id: _this8.me.uid
                }
              }));
              _context10.next = 43;
              break;
            case 33:
              _context10.prev = 33;
              _context10.next = 36;
              return useWalletStore().heroGateway.startDeposit(_this8.id, _this8.saveDepositTx);
            case 36:
              redirectTo = _this8.localePath({
                name: 'users-id-units-index-outgame',
                params: {
                  id: _this8.me.uid
                }
              });
              _this8.$router.push(redirectTo);
              _context10.next = 43;
              break;
            case 40:
              _context10.prev = 40;
              _context10.t0 = _context10["catch"](33);
              console.error(_context10.t0);
              // this.$toast.error('Cancelled.')
            case 43:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[33, 40]]);
      }))();
    },
    // Depositしたアセットの情報を保存
    saveDepositTx: function saveDepositTx(hash, tokenId) {
      var _this9 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var saveDatas, savedList, newDepositData;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              saveDatas = [{
                tx: '',
                assetId: 0,
                since: 0
              }];
              saveDatas.length = 0;
              savedList = _this9.$localStorage.get('unit-deposit-list') || '';
              if (savedList !== '') {
                saveDatas = JSON.parse(savedList);
              }
              newDepositData = {
                tx: hash,
                assetId: tokenId,
                since: _this9.now.format('X')
              };
              saveDatas.push(newDepositData);
              _this9.$localStorage.set('unit-deposit-list', JSON.stringify(saveDatas));
              _context11.next = 9;
              return _this9.$heroesService.setImportHero(tokenId);
            case 9:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    updateOutFee: function updateOutFee() {
      var _this10 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              if (!_this10.networkBool.isEth) {
                _context12.next = 6;
                break;
              }
              _context12.next = 3;
              return _this10.$extensionsService.getCurrentOutFeePpd();
            case 3:
              _this10.outFee = _context12.sent;
              _context12.next = 16;
              break;
            case 6:
              if (!_this10.networkBool.isMatic) {
                _context12.next = 12;
                break;
              }
              _context12.next = 9;
              return _this10.$heroesService.getCurrentOutFeeMatic();
            case 9:
              _this10.outFee = _context12.sent;
              _context12.next = 16;
              break;
            case 12:
              if (!_this10.networkBool.isHomeverse) {
                _context12.next = 16;
                break;
              }
              _context12.next = 15;
              return _this10.$heroesService.getCurrentOutFeeOasys();
            case 15:
              _this10.outFee = _context12.sent;
            case 16:
            case "end":
              return _context12.stop();
          }
        }, _callee12);
      }))();
    },
    // Withdrawしたアセットの情報を保存
    saveWithdraw: function saveWithdraw() {
      var _this11 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var saveDatas, savedList;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              saveDatas = [];
              saveDatas.length = 0;
              savedList = _this11.$localStorage.get('unit-withdraw-list') || '';
              if (savedList !== '') {
                saveDatas = JSON.parse(savedList);
              }
              saveDatas.push(_this11.id);
              _this11.$localStorage.set('unit-withdraw-list', JSON.stringify(saveDatas));
            case 6:
            case "end":
              return _context13.stop();
          }
        }, _callee13);
      }))();
    },
    withdraw: function withdraw() {
      var _this12 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var redirectTo;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              if (_this12.networkBool.isEth) {
                _this12.networkType = 1;
              } else if (_this12.networkBool.isMatic) {
                _this12.networkType = 2;
              } else if (_this12.networkBool.isHomeverse) {
                _this12.networkType = 3;
              }
              _context14.prev = 1;
              _context14.next = 4;
              return _this12.$heroesService.withdraw(_this12.id, _this12.outFee, _this12.networkType);
            case 4:
              _context14.next = 6;
              return _this12.saveWithdraw();
            case 6:
              _this12.$toast.success('Request accepted.');
              redirectTo = _this12.localePath({
                name: 'users-id-units-index-outgame',
                params: {
                  id: _this12.me.uid
                }
              });
              _this12.$router.push(redirectTo);
              _context14.next = 15;
              break;
            case 11:
              _context14.prev = 11;
              _context14.t0 = _context14["catch"](1);
              // grpcのバグ？でエラーが起きても到達しない
              console.error(_context14.t0);
              _this12.$toast.error('Error.');
            case 15:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[1, 11]]);
      }))();
    },
    getNew: function getNew(type, paramType) {
      if (!this.hero) return 0;
      var before = this.previousHero[type][paramType];
      var after = this.hero[type][paramType];
      if (before < after) return 1;
      if (before > after) return -1;
      return 0;
    },
    getNewLv: function getNewLv() {
      if (!this.hero) return 0;
      var before = this.previousHero.lv;
      var after = this.hero.lv;
      if (before < after) return 1;
      if (before > after) return -1;
      return 0;
    },
    getNewLvClass: function getNewLvClass() {
      var compareLv = this.getNewLv();
      if (compareLv === -1) return 'down';
      return 'noChange';
    },
    getNewParamClass: function getNewParamClass(type, paramType) {
      var compareParam = this.getNew(type, paramType);
      if (compareParam === 1) return 'up';
      if (compareParam === -1) return 'down';
      return 'noChange';
    },
    refreshStatus: function refreshStatus() {
      var _this13 = this;
      this.isRefreshAnimation = true;
      setTimeout( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var itemId;
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _this13.previousHero = _this13.$util.clone(_this13.hero);
              itemId = _this13.useConsumeItem ? _this13.useTicketId : 0;
              _context15.next = 5;
              return _this13.fetchRefreshedHero([_this13.id, itemId]);
            case 5:
              _context15.next = 7;
              return _this13.$itemsService.getConsumeItemsByProcType(100);
            case 7:
              _this13.consumeItems = _context15.sent;
              _this13.isRefreshAnimation = false;
              _this13.isAfterStatusRefresh = true;
              _context15.next = 16;
              break;
            case 12:
              _context15.prev = 12;
              _context15.t0 = _context15["catch"](0);
              console.error(_context15.t0);
              _this13.$toast.error('Not Enough CE');
            case 16:
            case "end":
              return _context15.stop();
          }
        }, _callee15, null, [[0, 12]]);
      })), 1000);
    },
    goToTrade: function goToTrade(heroType) {
      // grab trade filter from LS, add extensionType, then save back to LS
      var tradeFilter = JSON.parse(window.localStorage.getItem('mch:tradeHeroFilter')) || this.$util.clone(this.standardFilter);
      tradeFilter.assetType = heroType;
      window.localStorage.setItem('mch:tradeHeroFilter', JSON.stringify(tradeFilter));
      this.$router.push(this.localePath({
        name: 'market-index-trade-index-heroes'
      }));
    },
    onArtChanged: function onArtChanged() {
      var _this14 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16() {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              _context16.next = 2;
              return _this14.fetchHero(_this14.hero.heroId);
            case 2:
              _this14.isChangeArtModalShown = false;
            case 3:
            case "end":
              return _context16.stop();
          }
        }, _callee16);
      }))();
    },
    onSkillChanged: function onSkillChanged() {
      var _this15 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17() {
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              _context17.next = 2;
              return _this15.fetchHero(_this15.hero.heroId);
            case 2:
              _this15.isChangeSkillModalShown = false;
            case 3:
            case "end":
              return _context17.stop();
          }
        }, _callee17);
      }))();
    },
    fetchEquippedData: function fetchEquippedData() {
      var _this16 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18() {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              if (!(_this16.isMyUser && _this16.hero.lock)) {
                _context18.next = 7;
                break;
              }
              _context18.next = 3;
              return _this16.$teamsService.checkAssetDeck(1, _this16.id);
            case 3:
              _this16.isTeamingData = _context18.sent;
              if (_this16.isTeamingData.length) {
                _this16.isTeaming = true;
                _this16.isTeamingData.sort(function (p, c) {
                  if (p.deckTypeV2 < c.deckTypeV2) return -1;
                  if (p.deckTypeV2 > c.deckTypeV2) return 1;
                  return 0;
                });
              } else {
                _this16.isTeaming = false;
              }
              _context18.next = 8;
              break;
            case 7:
              _this16.isTeaming = false;
            case 8:
            case "end":
              return _context18.stop();
          }
        }, _callee18);
      }))();
    },
    gifted: function gifted(done) {
      var _this17 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19() {
        return regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) switch (_context19.prev = _context19.next) {
            case 0:
              _context19.next = 2;
              return _this17.$router.push(_this17.localePath({
                name: 'users-id-units-index-ingame',
                params: {
                  id: (_this17.me || {}).uid
                }
              }));
            case 2:
              done();
            case 3:
            case "end":
              return _context19.stop();
          }
        }, _callee19);
      }))();
    },
    teamingRemoval: function teamingRemoval() {
      var _this18 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20() {
        return regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) switch (_context20.prev = _context20.next) {
            case 0:
              _context20.prev = 0;
              _context20.next = 3;
              return _this18.$teamsService.releaseAssetDeck(1, _this18.id);
            case 3:
              _context20.next = 5;
              return _this18.fetchHero(_this18.id);
            case 5:
              _context20.next = 7;
              return useDeckTemplateStore().fetchDeckTemplates(true);
            case 7:
              _this18.$toast.success('Saved.');
              _context20.next = 14;
              break;
            case 10:
              _context20.prev = 10;
              _context20.t0 = _context20["catch"](0);
              console.error(_context20.t0);
              _this18.$toast.error('Error.');
            case 14:
              _context20.next = 16;
              return _this18.fetchEquippedData();
            case 16:
              _this18.isTeamingRemovalModalShown = false;
            case 17:
            case "end":
              return _context20.stop();
          }
        }, _callee20, null, [[0, 10]]);
      }))();
    },
    transferExp: function transferExp(heroItems, targetId) {
      var _this19 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21() {
        var userId, market, supplyData, lockData;
        return regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              _context21.prev = 0;
              _this19.isLoaded = true;
              _context21.next = 4;
              return _this19.$heroesService.useHeroExpItems(heroItems, targetId);
            case 4:
              _context21.next = 6;
              return _this19.fetchEthHeroIds();
            case 6:
              _context21.next = 8;
              return Promise.all([_this19.fetchHero(_this19.id), _this19.getOwner()]);
            case 8:
              userId = _this19.$route.query.uid;
              market = _this19.$route.query.market;
              if (market) {
                _this19.isMyUser = false;
              } else if (userId != null && _this19.me != null) {
                _this19.isMyUser = _this19.me.uid === Number(userId);
              }
              _context21.next = 13;
              return _this19.fetchEquippedData();
            case 13:
              _context21.next = 15;
              return _this19.$heroesService.getHeroTypeSupply(_this19.hero.heroType);
            case 15:
              supplyData = _context21.sent;
              _this19.supplyLimit = Number(supplyData.supply);
              _context21.next = 19;
              return _this19.$heroesService.getLockTransferUntil(_this19.id);
            case 19:
              lockData = _context21.sent;
              _this19.transferLockRemainingSec = Number(lockData.until);
              _this19.ingotCompositionModalShown = false;
              _this19.$toast.success('Success.');
              _context21.next = 29;
              break;
            case 25:
              _context21.prev = 25;
              _context21.t0 = _context21["catch"](0);
              _this19.isAbsorbing = false;
              _this19.$toast.error(_context21.t0);
            case 29:
            case "end":
              return _context21.stop();
          }
        }, _callee21, null, [[0, 25]]);
      }))();
    },
    upConvertModalOpen: function upConvertModalOpen() {
      var _this20 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee22() {
        var passiveSkill;
        return regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              _context22.prev = 0;
              _context22.next = 3;
              return _this20.$heroesService.preUpConvertHero(_this20.id);
            case 3:
              _this20.upConvertHero = _context22.sent;
              passiveSkill = useSkillMaster().getSkillById(_this20.upConvertHero.passive);
              _this20.upConvertHero.param.int = _this20.upConvertHero.param.pb_int;
              _context22.next = 8;
              return passiveSkill;
            case 8:
              _this20.upConvertHero.passiveSkill = _context22.sent;
              _this20.isUpConvertModalShown = true;
              _context22.next = 16;
              break;
            case 12:
              _context22.prev = 12;
              _context22.t0 = _context22["catch"](0);
              console.log(_context22.t0.message);
              _this20.$toast.error(_context22.t0.message);
            case 16:
            case "end":
              return _context22.stop();
          }
        }, _callee22, null, [[0, 12]]);
      }))();
    },
    upConvert: function upConvert() {
      var _this21 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee23() {
        return regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              _context23.prev = 0;
              _this21.isLoaded = true;
              _context23.next = 4;
              return _this21.$heroesService.upConvertHero(_this21.id);
            case 4:
              _this21.$toast.success('Success.');
              location.replace(_this21.localePath({
                name: 'units-id-index',
                params: {
                  id: _this21.upConvertHero.heroId
                }
              }));
              _context23.next = 12;
              break;
            case 8:
              _context23.prev = 8;
              _context23.t0 = _context23["catch"](0);
              console.log(_context23.t0.message);
              _this21.$toast.error(_context23.t0.message);
            case 12:
            case "end":
              return _context23.stop();
          }
        }, _callee23, null, [[0, 8]]);
      }))();
    },
    skillTreeShown: function skillTreeShown(detail) {
      this.isSkillTreeDetailShown = detail;
      this.isSkillTreeShown = true;
    },
    getWithdrawErrors: function getWithdrawErrors() {
      var withdrawErrors = [];
      if (this.ppdBalance < this.outFee) withdrawErrors.push(1);
      if (this.numberOfTransfered > this.$constants.WITHDRAW_LIMIT_IN_A_DAY) withdrawErrors.push(2);
      if (this.hero.lv <= 1 || this.artEditHistoryLength === 0) withdrawErrors.push(4);
      if (this.isNewMintedAsset) withdrawErrors.push(5);
      if (!this.isPhoneValid) withdrawErrors.push(6);
      return withdrawErrors;
    },
    onClickAgainButton: function onClickAgainButton() {
      this.isAfterStatusRefresh = false;
      this.checkUseConsumeItem();
    },
    checkUseConsumeItem: function checkUseConsumeItem() {
      // 所持数確認
      if (this.ticketCount <= 0) {
        this.useConsumeItem = false;
      }
    },
    spendPPD: function spendPPD(ppdAmount, heroItems, targetId) {
      var _this22 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee24() {
        var userId, market, supplyData, lockData;
        return regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) switch (_context24.prev = _context24.next) {
            case 0:
              _context24.prev = 0;
              _this22.isLoaded = true;
              _context24.next = 4;
              return _this22.$ppdService.spendPpdPurchaseHeroLv(ppdAmount, heroItems, targetId);
            case 4:
              _context24.next = 6;
              return _this22.fetchEthHeroIds();
            case 6:
              _context24.next = 8;
              return Promise.all([_this22.fetchHero(_this22.id), _this22.getOwner()]);
            case 8:
              userId = _this22.$route.query.uid;
              market = _this22.$route.query.market;
              if (market) {
                _this22.isMyUser = false;
              } else if (userId != null && _this22.me != null) {
                _this22.isMyUser = _this22.me.uid === Number(userId);
              }
              _context24.next = 13;
              return _this22.fetchEquippedData();
            case 13:
              _context24.next = 15;
              return useAddressStore().fetchPpdInfo();
            case 15:
              _context24.next = 17;
              return _this22.$heroesService.getHeroTypeSupply(_this22.hero.heroType);
            case 17:
              supplyData = _context24.sent;
              _this22.supplyLimit = Number(supplyData.supply);
              _context24.next = 21;
              return _this22.$heroesService.getLockTransferUntil(_this22.id);
            case 21:
              lockData = _context24.sent;
              _this22.transferLockRemainingSec = Number(lockData.until);
              _this22.ppdCompositionModalShown = false;
              _this22.$toast.success('Success.');
              _context24.next = 31;
              break;
            case 27:
              _context24.prev = 27;
              _context24.t0 = _context24["catch"](0);
              console.error(_context24.t0);
              _this22.$toast.error(_context24.t0);
            case 31:
            case "end":
              return _context24.stop();
          }
        }, _callee24, null, [[0, 27]]);
      }))();
    },
    isChangeNetworkNeeded: function isChangeNetworkNeeded() {
      if (this.isMyOwnEthHero && !this.networkBool.isEth) {
        this.changeNetworkModalOpen = true;
        this.changeNetworkNumber = 1;
      } else if (this.isMyOwnMaticHero && !this.networkBool.isMatic) {
        this.changeNetworkModalOpen = true;
        this.changeNetworkNumber = 2;
      } else if (this.isMyOwnOasysHero && !this.networkBool.isHomeverse) {
        this.changeNetworkModalOpen = true;
        this.changeNetworkNumber = 3;
      } else {
        this.depositModalOpen = true;
      }
    }
  }
};